<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="pa-3">
      <v-card-title>楽天アフィリエイト</v-card-title>
      <v-card-actions class="pw-10">
        <v-form
          ref="rakutenAffliatteSearchForm"
          style="width: 100%"
          lazy-validation
          @submit.prevent="submitKeyword()"
        >
          <v-row>
            <v-col cols="10">
              <v-text-field
                v-model="rakutenItemKeyword"
                label="キーワード入力"
                class="pw-5"
                :rules="[rakutenItemKeywordValidation]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn color="primary" @click="submitKeyword()">検索</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-actions>
      <v-row justify="space-around">
        <v-flex
          v-for="(rakutenItem, index) in rakutenaItems"
          v-show="!loading"
          :key="index"
          md4
          max-width="200"
        >
          <v-img :src="rakutenItem.imagesUrl[0]" class="ma-5"></v-img>
          <v-card-text>{{ rakutenItem.name }}</v-card-text>
          <v-card-actions class="pa-1">
            <v-btn color="primary" @click="getTargetItem(rakutenItem)">
              選択
            </v-btn>
            <v-btn color="primary" @click="getTargetItemSearch(rakutenItem)">
              検索リンク設定
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex
          v-for="key in '123456'"
          v-show="loading"
          :key="`skeleton_${key}`"
          class="px-2"
          md4
          max-width="200"
        >
          <v-skeleton-loader type="image, article, actions"></v-skeleton-loader>
        </v-flex>
        <v-card-text class="text-center">
          <span v-if="!haveRakutenItems()">検索結果がありません</span>
        </v-card-text>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: {
    rakutenDialog: {
      type: Boolean
    }
  },
  data: function () {
    return {
      rakutenaItems: [],
      rakutenItemKeyword: '',
      rakutenItemKeywordValidation: (value) => {
        if (!value || value.trim().length <= 1) { return '2文字以上の文字列を入力してください' }
        return true
      },
      setRakutenItem: {},
      loading: false,
      dialog: this.rakutenDialog
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  },
  watch: {
    rakutenDialog () {
      this.dialog = this.rakutenDialog
    },
    dialog (value) {
      if (value) return
      this.$emit('close-dialog', false)
    }
  },
  methods: {
    getTargetItem: function (rakutenItem) {
      if (!rakutenItem.affiliateSearch) {
        rakutenItem.affiliateSearch = ''
      }
      this.$emit('update-editing-rakuten-item', rakutenItem)
    },
    getTargetItemSearch: function (rakutenItem) {
      const affiliate = rakutenItem.affiliate.substring(
        0,
        rakutenItem.affiliate.indexOf('pc=')
      )
      const affiliateSearch =
        affiliate +
        'pc=' +
        'https://search.rakuten.co.jp/search/mall/' +
        rakutenItem.name

      if (!rakutenItem.affiliateSearch) {
        rakutenItem['affiliateSearch'] = affiliateSearch
      } else {
        rakutenItem.affiliateSearch = affiliateSearch
      }

      this.$emit('update-editing-rakuten-item', rakutenItem)
      this.$emit('rakuten-dialog', false)
    },
    haveRakutenItems () {
      return this.rakutenaItems && !!this.rakutenaItems.length
    },
    submitKeyword: function () {
      if (!this.$refs.rakutenAffliatteSearchForm.validate() || this.loading) { return }
      this.loading = true
      axios
        .get('/api/rakuten_items_info', {
          params: { keyword: this.rakutenItemKeyword }
        })
        .then(
          ({ data }) => {
            this.rakutenaItems.splice(0)
            this.rakutenaItems.push(...data)
          },
          () => {
            const payload = {
              status: 404,
              message: '商品が取得できませんでした'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped></style>
